export default {
  setApiEnv(state, url) {
    state.apiEnv = url
  },
  showLoading(state) {
    state.isLoading = true
  },
  closeLoading(state) {
    state.isLoading = false
  },
  setLang(state, locale) {
    if (state.locales.indexOf(locale) !== -1) {
      state.locale = locale

      localStorage.setItem('locale', locale)
    }
  },
  coverToken(state, token) {
    state.accessToken = token
  },
  setUserName(state, name) {
    state.userName = name
  },
  setIsLogin(state) {
    state.isLogin = true
  },
  logOut(state) {
    state.isLogin = false
    localStorage.removeItem('permissions')
  },
  // 刷新指定页面的标记状态
  refresh(state, flagName) {
    state.flag[flagName] = !state.flag[flagName]
  },
  regionList(state, regionList) {
    state.regionList = regionList
  },
  /** 未读消息数 */
  setMessageNotReadTotal(state, count) {
    state.messageNotReadTotal = count >= 0 ? count : 0
  },
  setStoreInfo(state, info) {
    state.storeInfo = info
  },
  setOpenRegionStations(state, regionList) {
    state.openRegionStations = regionList
  },
  setLangText(state, locale) {
    state.localText = locale.toUpperCase()
  },
  setMenuAllData(state, menuAllData) {
    state.menuAllData = menuAllData
  },
  setStoreRegionId(state, info) {
    state.storeRegionId = info
  },
  setRegisterStoreInfo(state, info) {
    state.registerStoreInfo = info
  }

}
